module.exports = __webpack_public_path__ + "img/order-ticket-free-status.4fa2837a.svg";